import type { BadgeVariant } from '@palmetto/palmetto-components';

import { SalesRepStatus } from 'types';

export const salesRepStatusBadgeVariant: Record<SalesRepStatus, BadgeVariant> = {
  [SalesRepStatus.active]: 'success',
  [SalesRepStatus.watchlist]: 'warning',
  [SalesRepStatus.noNewSales]: 'warning',
  [SalesRepStatus.suspended]: 'danger',
  [SalesRepStatus.terminated]: 'danger',
  [SalesRepStatus.blocked]: 'danger',
  [SalesRepStatus.temporarySuspend]: 'warning',
  [SalesRepStatus.override]: 'info',
  [SalesRepStatus.stale]: 'default',
};
